import React from 'react'
import clsx from 'clsx'
import { Fab } from '@material-ui/core'

import {
  ExpandMore as ExpandMoreIcon,
  NavigateBefore as NavigateBeforeIcon,
  NavigateNext as NavigateNextIcon,
} from '@material-ui/icons'

const NavFabs = props => {

  return (
    <React.Fragment>
      <Fab
        color="primary"
        aria-label="navigation-projects-menu"
        onClick={e => props.setDrawer(props.drawer ? false : true)}
        className={clsx({
          [props.classes.drawerIcon]: true,
          [props.classes.drawerIconClosed]: !props.drawer,
          [props.classes.drawerIconOpened]: props.drawer
        })}
      >
        <ExpandMoreIcon />
      </Fab>
      <Fab
        color="secondary"
        aria-label="navigation-next-project"
        onClick={e => props.next(props.path)}
        className={props.classes.navIconNext}
      >
        <NavigateNextIcon />
      </Fab>
      <Fab
        color="secondary"
        aria-label="navigation-previous-project"
        onClick={e => props.prev(props.path)}
        className={props.classes.navIconBefore}
      >
        <NavigateBeforeIcon />
      </Fab>
    </React.Fragment>
  )
}

export default NavFabs